import { Dialog, DialogContent, DialogTitle, VisuallyHidden } from "../../components/ui/dialog";
import { ClientForm } from "../../forms/form-components/client/insert/client.form";
import { Database } from "@/lib/supabase";

export const ClientManagementDialog: React.FC<{
	open: boolean;
	onClose: (client?: Database["public"]["Tables"]["clients"]["Row"]) => void;
}> = ({ open, onClose }) => {
	const handleSaveClient = (client?: Database["public"]["Tables"]["clients"]["Row"]) => {
		onClose(client);
	};
	const handleClose = () => {
		onClose();
	};
	return (
		<Dialog
			open={open}
			onOpenChange={handleClose}
			data-testid="client-management-dialog"
		>
			<DialogContent className="sm:max-w-2xl max-h-[80vh] flex flex-col">
				<VisuallyHidden>
					<DialogTitle>Kunde verwalten</DialogTitle>
				</VisuallyHidden>
				<div className="flex-1 min-h-0 overflow-y-auto">
					<ClientForm onSave={handleSaveClient} />
				</div>
			</DialogContent>
		</Dialog>
	);
};
